<template>
    <v-row no-gutters>
        <reports-sessions v-if="selectedLogType === 'sessions'"></reports-sessions>
        <reports-tools v-if="selectedLogType === 'tools'"></reports-tools>
    </v-row>
</template>

<script>
  import ReportsSessions from "../components/MainContent/Reports/ReportsSessions";
  import ReportsTools from "../components/MainContent/Reports/ReportsTools";

  export default {
    name: "Reports",
    components: {ReportsTools, ReportsSessions},
    computed: {
      selectedLogType() {
        return this.$store.getters['reports/SEARCH_TYPE']
      },
    },
    data() {
      return {}
    }
  }
</script>

<style scoped>

</style>
